import api from './api';
import { Ramo, CreateRamoDTO, UpdateRamoDTO } from '../types/ramo';

export const ramoService = {
  // Listar todos os ramos
  listarRamos: async (): Promise<Ramo[]> => {
    const response = await api.get('/ramos');
    return response.data;
  },

  // Buscar um ramo específico
  buscarRamo: async (id: number): Promise<Ramo> => {
    const response = await api.get(`/ramos/${id}`);
    return response.data;
  },

  // Criar um novo ramo
  criarRamo: async (ramo: CreateRamoDTO): Promise<Ramo> => {
    const response = await api.post('/ramos', ramo);
    return response.data;
  },

  // Atualizar um ramo existente
  atualizarRamo: async (id: number, ramo: UpdateRamoDTO): Promise<Ramo> => {
    const response = await api.put(`/ramos/${id}`, ramo);
    return response.data;
  },

  // Excluir um ramo
  excluirRamo: async (id: number): Promise<void> => {
    await api.delete(`/ramos/${id}`);
  }
}; 